import request from "./http";

class AuthenticationRepository
{
    async loginWithPassword(username, password) {
        const path = "auth/login";
        const method = "POST";
        const data = {
            username: username,
            password: password
        };

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

    async logout() {
        const path = "auth/logout";
        const method = "POST";
        const data = null;

        try {
            const response = await request(path, method, data);

            return response.data;
        } catch (error) {
            console.error(error);
        }
    }

}

export default AuthenticationRepository;